import React from 'react';

function Star({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <path d="M15.5772 7.56919L15.6908 7.81033L15.9543 7.85043L23.1474 8.94514C23.1476 8.94517 23.1478 8.9452 23.148 8.94523C23.3579 8.97823 23.5333 9.19327 23.4947 9.45536L23.4947 9.45535L23.494 9.46065C23.4801 9.56257 23.4346 9.65353 23.3682 9.72186C23.3681 9.72201 23.3679 9.72217 23.3678 9.72232L18.1632 15.036L17.986 15.2168L18.027 15.4667L19.2568 22.9712L19.2568 22.9715C19.3006 23.2371 19.1277 23.456 18.9218 23.4932L18.921 23.4934C18.8382 23.5084 18.7521 23.4944 18.6788 23.4536L18.6765 23.4523L12.2412 19.9093L12.0001 19.7765L11.7589 19.9093L5.3236 23.4523L5.32282 23.4527C5.25742 23.4889 5.18556 23.5043 5.11487 23.499C5.04412 23.4937 4.97399 23.4677 4.91268 23.421C4.85112 23.3742 4.80044 23.308 4.76936 23.2278C4.73823 23.1475 4.7289 23.0586 4.74323 22.9718L4.74334 22.9712L5.97316 15.4667L6.0141 15.2168L5.83694 15.036L0.631457 9.7214L0.631425 9.72137C0.551388 9.63967 0.501643 9.52329 0.50004 9.39652C0.49844 9.27007 0.544997 9.15229 0.622935 9.06805C0.688113 8.99868 0.768093 8.9578 0.849795 8.94558L0.851048 8.94539L8.04578 7.85043L8.3093 7.81033L8.42288 7.56919L11.638 0.743642C11.6382 0.743308 11.6383 0.742975 11.6385 0.742641C11.7477 0.515243 11.9899 0.447524 12.1728 0.542094L12.1734 0.542399C12.2509 0.582344 12.3184 0.65064 12.3608 0.740845L12.361 0.741269L15.5772 7.56919Z" />
    </svg>
  );
}

export default Star;
